import composeFp from 'lodash/fp/compose';
import { TOutputData } from '../../../services/body/types';
import { bodyToPlainString } from '../../../services/body/bodyToPlainString';

export const getShortDescriptionFromString = (data: string) => data.split(/\s+/).slice(0, 30).join(' ');

export const getShortDescriptionFromBody = (body: TOutputData) =>
  composeFp(getShortDescriptionFromString, bodyToPlainString)(body);
